import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import View from "./View";

const Configure = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, loading, error, refetch } = useQuery(graphql.queries.INSURANCE_PLAN, {
    variables: { where: { id } },
    fetchPolicy: "network-only",
  });

  const [updateInsurancePlan] = useMutation(
    graphql.mutations.UPDATE_INSURANCE_PLAN,
  );

  const cancel = () =>
    navigate(
      `${SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.DETAIL.path}/${id}`,
    );

  if (loading) return "Chargement...";
  if (error) return `Erreur : ${error.message}`;

  return (
    <View
      data={data.insurancePlan}
      updateInsurancePlan={updateInsurancePlan}
      cancel={cancel}
      refetch={refetch}
    />
  );
};

export default Configure;
